export default (ageInMonths) => {
  const age = Math.abs(ageInMonths);
  const ageInYears = age / 12;
  return Math.round(ageInYears / 0.5) * 0.5;
};
